<div fxLayout="column" fxFlexFill>
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table responsive"
               matSort matSortActive="ipAddress" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="ipAddress">
        <mat-header-cell *matHeaderCellDef mat-sort-header="ipAddress">IP Address</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">IP Address:</span>
          <a *ngIf="hasEditAccess" [routerLink]="[detailsUrl, row.id, 'edit']">
            {{ row.ipAddress }}
          </a>
          <span *ngIf="!hasEditAccess">{{ row.ipAddress }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header="startOn">Valid From</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Valid From:</span>
          {{ row.startOn  | dateTime:'M/dd/yyyy' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="endOn">
        <mat-header-cell *matHeaderCellDef mat-sort-header="endOn">Valid To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Valid To:</span>
          {{ row.endOn  | dateTime:'M/dd/yyyy' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="customerNote">
        <mat-header-cell *matHeaderCellDef mat-sort-header="customerNote">Agent/Group</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Agent/Group:</span>
          {{ row.customerNote }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="additionalNotes">
        <mat-header-cell *matHeaderCellDef mat-sort-header="additionalNotes">Notes</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Notes:</span>
          {{ row.additionalNotes }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="notifyExpiration">
        <mat-header-cell *matHeaderCellDef mat-sort-header="notifyExpiration">Notification</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Notification:</span>
          <div style="width: 100%">
            {{ row.notifyExpiration ? 'Yes' : 'No' }}
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="recipients">
        <mat-header-cell *matHeaderCellDef>Recipients</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Recipients:</span>
          {{ row.recipients?.join(', ') }}
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
